import type { DataSourceConnectorRef } from '#layers/data-model/utils/data-source-connector-lookup';
import { useDataSourceConnectors } from '#layers/data-model/composables/use-data-source-connectors';

/** Icon shown for a data source whose connector has no icon of its own. */
export const DEFAULT_CONNECTOR_ICON = 'lucide:database';

export function useDataSourceConnectorDisplay() {
	const { getDataSourceConnector } = useDataSourceConnectors();

	/** Props for `ConnectorLogo`, falling back to a generic database icon. */
	function getConnectorLogoProps(source: DataSourceConnectorRef) {
		const connector = getDataSourceConnector(source);

		return {
			icon: connector?.icon ?? DEFAULT_CONNECTOR_ICON,
			iconForeground: connector?.iconForeground,
			iconBackground: connector?.iconBackground,
		};
	}

	/** Human-readable connector name, falling back to the raw provider. */
	function getConnectorName(source: DataSourceConnectorRef) {
		return getDataSourceConnector(source)?.name ?? source.provider;
	}

	return {
		getConnectorLogoProps,
		getConnectorName,
	};
}
